<div>
  <b>Anschlussobjekt:&nbsp;</b>
  <!-- prettier-ignore -->
  <ng-container *ngIf='createUpdateEntity?.connectionObject?.city as city'>
    <span>{{ createUpdateEntity?.connectionObject?.zipCode }} {{ city }}</span></ng-container>
  <!-- prettier-ignore -->
  <ng-container *ngIf='createUpdateEntity?.connectionObject?.district as district'>, <span>{{ district }}</span>
  </ng-container>
  <!-- prettier-ignore -->
  <ng-container *ngIf='createUpdateEntity?.connectionObject?.street as street'>,
    <span>{{ street }} {{ createUpdateEntity?.connectionObject?.streetNo }}</span></ng-container>
  <br />
  <ng-container *ngIf="createUpdateEntity?.customer?.salutation">
    <b>Kontakt Anschlussnehmer:</b>
    <span>
      {{ createUpdateEntity?.customer?.salutation | salutationTitle | async }}
      <ng-container *ngIf="createUpdateEntity?.customer?.salutation | isPerson | async; else isCompany">
        {{ createUpdateEntity?.customer?.firstName }} {{ createUpdateEntity?.customer?.lastName }}
      </ng-container>
      <ng-template #isCompany>
        {{ createUpdateEntity?.customer?.company }} {{ createUpdateEntity?.customer?.companyAddition }}
      </ng-template>
      - {{ createUpdateEntity?.customer.phone }}, {{ createUpdateEntity?.customer.mail }}
    </span>
  </ng-container>
  <br />
  <ng-container *ngIf="createUpdateEntity?.technician?.contactData">
    <b>Kontakt Solateur/Installateur:</b>

    <ng-container *ngIf="createUpdateEntity?.technician?.businessPartner?.contactData?.readable">
      {{ createUpdateEntity?.technician?.businessPartner?.contactData?.readable }},
    </ng-container>
    <span>
      {{ createUpdateEntity?.technician?.contactData?.readable }}
    </span>
    <ng-container
      *ngIf="
        createUpdateEntity?.technician?.contactData?.phone ||
        createUpdateEntity?.technician?.contactData?.mail
      ">
      - {{ createUpdateEntity?.technician?.contactData?.phone }}
      {{ createUpdateEntity?.technician?.contactData?.mail }}
    </ng-container>
  </ng-container>
</div>
